<div class="card">
  <div class="card-header">
    <h2 class="fs-3 fw-bold mb-0">{{ 'label.exam-event-list' | translate }}</h2>
  </div>
  <div class="card-body">
    <table class="table table-hover table-striped">
      <thead>
        <tr>
          <th class="cursor-pointer" (click)="sortBy('testeventTime')">
            {{ 'label.time' | translate }}
            <i 
              class="bi" 
              [class]="sortColumn === 'testeventTime' ? (sortDirection === 'asc' ? 'bi-caret-up-fill' : 'bi-caret-down-fill') : 'bi-funnel-fill text-muted'">
            </i>
          </th>
          <th class="cursor-pointer" (click)="sortBy('testId')">
            {{ 'label.exams.exam' | translate }}
            <i 
              class="bi" 
              [class]="sortColumn === 'testId' ? (sortDirection === 'asc' ? 'bi-caret-up-fill' : 'bi-caret-down-fill') : 'bi-funnel-fill text-muted'">
            </i>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let row of items"
          (click)="rowClicked(row)"
          class="cursor-pointer"
        >
          <td>{{ row.testeventTime | localizedDate: 'medium' }}</td>
          <td>
            <div class="test-name">{{ getTestName(row) }}</div>
            <img
              *ngIf="getTestLogo(row)"
              [src]="getTestLogo(row)"
              [alt]="getTestName(row)"
              class="test-logo"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<button
  (click)="createButtonClicked()"
  class="btn btn-primary rounded-circle d-flex align-items-center justify-content-center add-button"
>
  <i class="bi bi-plus-lg"></i>
</button>
